export default "__VITE_ASSET__0e8ec4c2__"